import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function Brief() {
  const [data, setData] = useState(null);
  const [overdraftStatus, setOverdraftStatus] = useState('');
  const [demoRisk, setDemoRisk] = useState(false);
  const [doneTasks, setDoneTasks] = useState([]);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetch(API + '/khepri/brief', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(setData);
  }, []);

  const requestOverdraft = () => {
    setOverdraftStatus('pending');
    setTimeout(() => {
      setOverdraftStatus('approved');
    }, 2000);
  };

  const toggleTask = (id) => {
    setDoneTasks(prev => prev.includes(id) ? prev.filter(t => t !== id) : [...prev, id]);
  };

  const hasRisk = data?.has_risk || demoRisk;

  if (!data) return <p style={{color:'#94A3B8'}}>Загрузка...</p>;

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={() => { setDemoRisk(!demoRisk); setOverdraftStatus(''); }}
          style={{
            padding: '6px 14px',
            background: demoRisk ? '#EF4444' : '#334155',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {demoRisk ? '🟢 Скрыть демо' : '🔴 Демо: Кассовый разрыв'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Баланс</div>
          <div style={{ fontSize: 16, fontWeight: 700 }}>{(data.balance || 0).toLocaleString()} РУБ</div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Прогноз</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: hasRisk ? '#EF4444' : '#10B981' }}>{hasRisk ? 'РИСК' : 'НОРМА'}</div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Ближайший платёж</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{(data.upcoming_tax_events || [])[0]?.name?.slice(0, 15) || 'Нет'}</div>
        </div>
      </div>

      {hasRisk && (
        <div style={{ marginBottom: 20, padding: 16, background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <div>
              <strong style={{ color: '#EF4444' }}>⚠️ Обнаружен кассовый разрыв!</strong>
              <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4 }}>
                {data.red_days > 0
                  ? `Кассовый разрыв через ${data.red_days} дн. Баланс будет отрицательным.`
                  : 'Баланс низкий. Рекомендуем оформить овердрафт.'}
              </p>
            </div>
            <button
              onClick={requestOverdraft}
              disabled={overdraftStatus === 'pending' || overdraftStatus === 'approved'}
              style={{
                padding: '10px 20px',
                background: overdraftStatus === 'approved' ? '#10B981' : overdraftStatus === 'pending' ? '#F59E0B' : '#6366F1',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: overdraftStatus === 'approved' ? 'default' : 'pointer',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}
            >
              {overdraftStatus === 'approved' ? '✓ Овердрафт одобрен (200 000 ₽)' : overdraftStatus === 'pending' ? 'Обработка...' : 'Запросить овердрафт'}
            </button>
          </div>
          {overdraftStatus === 'approved' && (
            <p style={{ color: '#10B981', fontSize: 13, marginTop: 8 }}>
              Сбербанк предварительно одобрил овердрафт: 200 000 ₽ под 18% годовых. Средства доступны через 5 минут.
            </p>
          )}
          {overdraftStatus === '' && (
            <p style={{ color: '#94A3B8', fontSize: 11, marginTop: 8 }}>
              Демо кредитного консьержа. Полная интеграция с банками-партнёрами скоро.
            </p>
          )}
        </div>
      )}

      <h3 style={{ marginBottom: 10 }}>Задачи</h3>
      {(data.tasks || []).map(t => {
        const done = doneTasks.includes(t.id);
        return (
          <div key={t.id} onClick={() => toggleTask(t.id)} style={{ padding: 10, marginBottom: 6, background: '#1E293B', borderRadius: 8, borderLeft: '3px solid ' + (t.priority === 'critical' ? '#EF4444' : t.priority === 'high' ? '#F59E0B' : '#6366F1'), fontSize: 13, cursor: 'pointer', opacity: done ? 0.5 : 1 }}>
            <span style={{ marginRight: 8 }}>{done ? '✅' : '⬜'}</span>
            <span style={{ textDecoration: done ? 'line-through' : 'none' }}>{t.text}</span>
          </div>
        );
      })}

      {(data.risks || []).length > 0 && (
        <div style={{ marginTop: 16, padding: 12, background: 'rgba(239,68,68,0.15)', borderRadius: 8, fontSize: 14 }}>
          {data.risks[0].description}
        </div>
      )}

      <h3 style={{ marginTop: 20, marginBottom: 10 }}>Прогноз на 14 дней</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <thead><tr style={{ color: '#94A3B8' }}><th>Дата</th><th>Баланс</th><th>Приход</th><th>Расход</th><th>Риск</th></tr></thead>
        <tbody>
          {(data.forecast_14d || []).slice(0, 14).map((p, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 4 }}>{p.date?.slice(5)}</td>
              <td style={{ padding: 4, textAlign: 'right' }}>{Math.round(p.balance).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#10B981' }}>+{Math.round(p.income).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#EF4444' }}>-{Math.round(p.expense).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'center' }}>{p.risk === 'red' ? '🔴' : p.risk === 'yellow' ? '🟡' : '🟢'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Brief;